import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import {
  GameListResponseType,
  loginGameResType,
  loginGameType,
  SubGameResponseType,
} from "types/game";

export const GameApi = {
  async getListGame(game_type: string) {
    const response = await axiosRequest.post<GameListResponseType>(
      "",
      payloadHelper("GetGameList", game_type, { game_type })
    );
    return response.data;
  },
  async getSubGame(
    typename: string,
    providername: string | undefined,
    featured: number | undefined,
    lobby: number | undefined,
    page: number | undefined,
    size: number | undefined
  ) {
    const response = await axiosRequest.post<SubGameResponseType>(
      "",
      payloadHelper("GetSubGameList", null, {
        provider: providername,
        game_type: typename,
        featured,
        lobby,
        page,
        size,
      })
    );
    return response.data;
  },
  async loginGame(typename: string, payload: loginGameType, device: number) {
    const response = await axiosRequest.post<loginGameResType>(
      "",
      payloadHelper("LoginGame", typename, payload, device),
      {
        cancelToken: payload.source?.token,
      }
    );
    return response.data;
  },
};
